export var HEADER_ELEMENT_ID = 'DayPicker_header';
//# sourceMappingURL=consts.js.map